import { Dialog, Transition } from '@headlessui/react';
import { PencilIcon } from '@heroicons/react/solid';
import axios from 'axios';
import { Field, FieldArray, Form, Formik } from 'formik';
import { Fragment, useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import LanguageList from '../../../../SharedComponents/LanguageList';
import Notification from '../../../../SharedComponents/Notification';
import ChairPersonsList from './ChairPersonsList';
import InstructorsList from './InstructorsList';

export default function EditChairPersonToPage(props) {
  const params = useParams();
  const id = params.id;
  const { languages, chairPerson } = props;
  const [languageId, setLanguageId] = useState(parseInt(window.env.REACT_APP_DEFAULT_LANGUAGE));
  const chairsPersonsTalkersLngs = languages?.map((language) => {
    return {
      languageId: language.id,
      title: '',
    };
  });
  const initValues = chairPerson;
  let [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const queryClient = useQueryClient();
  const addChairPersonMutation = useMutation(addChairPerson, {
    onSuccess: () => {
      toast(<Notification message={t('Added, Successfully')} />);
      queryClient.invalidateQueries('page');
      closeModal();
    },
    onError: () => {
      toast(<Notification message={t('Network Error')} />);
    },
  });
  const onSubmit = (e) => {
    addChairPersonMutation.mutate(e);
  };
  return (
    <>
      <div className="flex items-center justify-end">
        <button
          type="button"
          onClick={openModal}
          className={`bg-green-100 text-green-800 hover:bg-green-200  p-1 rounded transition duration-300 ease-in-out`}
        >
          <PencilIcon className="h-4" />
        </button>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto" onClose={closeModal}>
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-900 bg-opacity-80 " />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-4xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <div className="flex justify-between border-b">
                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                    {t('Edit Chair Person')}
                  </Dialog.Title>
                  <LanguageList languageId={languageId} setLanguageId={setLanguageId} languages={languages} />
                </div>
                <div className="mt-2">
                  <Formik onSubmit={onSubmit} enableReinitialize initialValues={initValues}>
                    {({ values, setFieldValue, setValues, errors }) => {
                      return (
                        <Form>
                          <div>
                            {/* <FieldArray
                              name="chairsPersonsTalkersLngs"
                              render={(arrayHelpers) => (
                                <>
                                  {values.chairsPersonsTalkersLngs.map((e, index) => {
                                    return (
                                      <Fragment key={index + 100}>
                                        {languageId === e.languageId && (
                                          <>
                                            <label>
                                              <Field
                                                className="border rounded  w-full  mb-4 p-2 mt-2 "
                                                type="text"
                                                placeholder={t('Add Speak Title')}
                                                name={`chairsPersonsTalkersLngs[${index}].title`}
                                              />
                                            </label>
                                          </>
                                        )}
                                      </Fragment>
                                    );
                                  })}
                                </>
                              )}
                            /> */}
                            <ChairPersonsList
                              chairsPersonsId={values.chairsPersonsId}
                              languageId={languageId}
                              setFieldValue={setFieldValue}
                            />
                            {/* <div className="flex space-x-2">
                              <Field className="border rounded  w-full  p-2 mt-2 " name="timeFrom" type="time" />
                              <Field className="border rounded  w-full  p-2 mt-2 " name="timeTo" type="time" />
                            </div> */}
                          </div>
                          <div
                            className="mt-4
                           flex justify-end"
                          >
                            <button type="submit" className="bg-green-500 text-white px-4 py-2 rounded">
                              {t('Save')}
                            </button>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export const addChairPerson = async (e) => {
  const data = await axios.post('/ChairsPersonsTalkers/Edit', e);
  return data;
};
